import React, { useState } from 'react';
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import AutosuggestComponent from "../document/AutosuggestComponent";
import DocumentPastdueAccountFirstNotice from '../document/DocumentPastdueAccountFirstNotice';


function PastdueAccountFirstNotice() {
    const [applicantDetails, setApplicantDetails] = useState(null);
    const [loanProcessingDetails, setLoanProcessingDetails] = useState([]);

    return (
        <>
            <NavMain slug="pastdue-account-first-notice" parent="6" />
            <HeaderMain slug="pastdue-account-first-notice" />
            <div className="main-content documents">
                <AutosuggestComponent
                setApplicantDetails={setApplicantDetails}
                setLoanProcessingDetails={setLoanProcessingDetails}
                />
                <DocumentPastdueAccountFirstNotice
                    applicantDetails={applicantDetails}
                    loanProcessingDetails={loanProcessingDetails}
                />
            </div>
        </>
    );
}

export default PastdueAccountFirstNotice;